export default __webpack_public_path__ + "static/media/webviperslogo.9d380396.png";